import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Table, ButtonGroup, Glyphicon, Row, Col, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

const FETCH_URL = "api/companies/admin"

class BedrijvenOverzicht extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handleChangePageSize = this.handleChangePageSize.bind(this)
        this.handleSortingClick = this.handleSortingClick.bind(this)
        this.getCompanies = this.getCompanies.bind(this)
        this.handleChangeSearch = this.handleChangeSearch.bind(this);
        this.handleClickSearch = this.handleClickSearch.bind(this);
        this.state = {
            companies: [],
            Id: "sorting",
            Name: "sorting",
            City: "sorting",
            ZipCode: "sorting",
            Address: "sorting",
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 10,
                totalCount: 0,
                orderBy: "",
                searchQuery: "",
            },
            currentFetchUrl: FETCH_URL // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handleChangePageSize(e) {
        this.setState({ pagination: { ...this.state.pagination, pageSize: e.target.value } })
        this.getCompanies(FETCH_URL + "?PageSize=" + e.target.value + (this.state.pagination.searchQuery == "" ? "" : "&SearchQuery=" + this.state.pagination.searchQuery) + (this.state.pagination.orderBy == "" ? "" : "&OrderBy=" + this.state.pagination.orderBy))
    }
    handleChangeSearch(e) {
        this.setState({ pagination: { ...this.state.pagination, searchQuery: e.target.value } })
    }
    handleClickSearch(e) {
        this.getCompanies(FETCH_URL + "?SearchQuery=" + this.state.pagination.searchQuery + "&PageSize=" + this.state.pagination.pageSize + (this.state.pagination.orderBy == "" ? "" : "&OrderBy=" + this.state.pagination.orderBy))
    }
    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.   
    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `${FETCH_URL}/${id}`
        if (window.confirm('Are you sure you wish to delete this item?')) {
            Api.print(`DELETE ${FETCH_URL_DELETE}`)
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete company with id: ${id}`)
                Api.print(response)
                this.getCompanies(this.state.currentFetchUrl) // Update the companies list
            })
        }
    }
    handleSortingClick(e) {
        var newSort = this.state.pagination.orderBy.indexOf(e) >= 0 ? this.state.pagination.orderBy.indexOf("asc") >= 0 ? this.state.pagination.orderBy.replace("asc", "desc") : this.state.pagination.orderBy.replace("desc", "asc") : e + " asc";
        this.setState({ Id: "sorting" })
        this.setState({ Name: "sorting" })
        this.setState({ City: "sorting" })
        this.setState({ ZipCode: "sorting" })
        this.setState({ Address: "sorting" })
        this.setState({ [e]: newSort.indexOf("asc") >= 0 ? "sorting_asc" : "sorting_desc" })
        this.setState({ pagination: { ...this.state.pagination, orderBy: newSort } })
        this.getCompanies(FETCH_URL + "?OrderBy=" + newSort + "&PageSize=" + this.state.pagination.pageSize + (this.state.pagination.searchQuery == "" ? "" : "&SearchQuery=" + this.state.pagination.searchQuery))
    }
    getCompanies(fetchUrl) {
        Api.print(`GET ${fetchUrl}`)
        Api.GetTableApi(fetchUrl, this.handleClick).then(response => {
            Api.print("Response")
            Api.print(response)
            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            Api.print("Companies)")
            Api.print(objectData)
            Api.print("----------")
            if (objectData !== undefined)
                this.setState({ companies: objectData.companies }); // Companies object
        })
    }

    componentDidMount() {
        this.getCompanies(FETCH_URL)
    }

    handleClick(e) {
        const fetchUrl = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.getCompanies(fetchUrl)
        this.setState({ currentFetchUrl: fetchUrl })
    }

    render() {
        let companies = this.state.companies
        return (
            <div>
                <Row>
                    <Col md={6} sm={12}>
                        <LinkContainer to="/admin/bedrijven/toevoegen">
                            <Button>
                                Bedrijf toevoegen
                        </Button>
                        </LinkContainer>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form inline>
                            <FormGroup controlId="formInlineName">
                                <ControlLabel>Zoek</ControlLabel>{' '}
                                <FormControl type="text" name='searchWord' placeholder="naam" onChange={this.handleChangeSearch} />
                            </FormGroup>{' '}
                            <Button type="button" onClick={this.handleClickSearch}>Zoeken</Button>
                        </Form>
                    </Col>
                </Row>
                <hr />
                <br /><br />
                <Row>
                    <Col md={1} sm={1}>
                        <FormControl name='pageSize' componentClass="select" placeholder="select" onChange={this.handleChangePageSize} value={this.state.pagination.pageSize}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="0">All</option>
                        </FormControl>
                    </Col>
                </Row>
                <Table responsive striped bordered hover className="dataTable">
                    <thead>
                        <tr>
                            <th className={this.state.Id} onClick={() => this.handleSortingClick("Id")}>id</th>
                            <th className={this.state.Name} onClick={() => this.handleSortingClick("Name")}>naam</th>
                            <th className={this.state.City} onClick={() => this.handleSortingClick("City")}>plaats</th>
                            <th className={this.state.ZipCode} onClick={() => this.handleSortingClick("ZipCode")}>postcode</th>
                            <th className={this.state.Address} onClick={() => this.handleSortingClick("Address")}>adres</th>
                            <th>telefoon</th>
                            <th>website</th>
                            <th>uitv.</th>
                            <th>ing.</th>
                            <th>logo</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {companies !== undefined ? companies.map((comp) => {
                            let editUrl = `/admin/bedrijven/bewerken/${comp.id}`
                            return (<tr key={comp.id}>
                                <td>{comp.id}</td>
                                <td>{comp.name}</td>
                                <td>{comp.city}</td>
                                <td>{comp.zipCode}</td>
                                <td>{comp.address}</td>
                                <td>{comp.phone}</td>
                                <td>{comp.website}</td>
                                <td>{comp.executive ? 'ja' : 'nee'}</td>
                                <td>{comp.engineering ? 'ja' : 'nee'}</td>
                                <td className="text-center" style={{ padding: "2px", height: "37px", width: "100px" }}>{comp.logo === "" ? "" : <img src={Api.Url + comp.logo} alt={"Logo van " + comp.name} className="img-responsive" style={{ display: "initial", maxHeight: "30px" }} />}</td>
                                <td >
                                    <ButtonGroup>
                                        <LinkContainer to={editUrl}>
                                            <Button bsSize="xsmall" className="edit">
                                                <Glyphicon glyph="pencil" />
                                            </Button>
                                        </LinkContainer>
                                        <Button bsSize="xsmall" className="delete" onClick={this.handleDelete(comp.id)}>
                                            <Glyphicon glyph="remove" />
                                        </Button>
                                    </ButtonGroup></td>
                            </tr >)
                        }) : null}
                    </tbody>
                </Table>
                <div className="paginationStyling">
                    <div style={{ float: 'left' }}>
                        {this.state.pagination.prevButton}
                    </div>
                    <div style={{ float: 'center' }}>
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div style={{ float: 'right' }}>
                        {this.state.pagination.nextButton}
                    </div>
                </div>
            </div>
        );
    }
}

export default BedrijvenOverzicht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Bedrijven/Overview.js